import { useEffect, useState } from "react";
import { useI18n } from "../lib/i18n";
import { Button } from "./ui/button";
import { Link, useLocation } from "react-router-dom";

const STORAGE_KEY = "cookie_consent_v1";

export default function CookieBanner() {
  const { lang } = useI18n();
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => { localStorage.setItem(STORAGE_KEY, "accepted"); setVisible(false); };
  const decline = () => { localStorage.setItem(STORAGE_KEY, "declined"); setVisible(false); };

  // Hide banner on the logged-in app routes to avoid overlapping the workspace UI
  if (location.pathname.startsWith("/app")) return null;
  if (!visible) return null;

  const text = {
    en: "We use essential cookies to keep you logged in and remember your language. No tracking, no ads.",
    it: "Usiamo cookie essenziali per mantenerti loggato e ricordare la tua lingua. Nessun tracciamento, nessuna pubblicita'.",
    es: "Usamos cookies esenciales para mantener tu sesión y recordar tu idioma. Sin tracking ni anuncios.",
    fr: "Nous utilisons des cookies essentiels pour votre session et votre langue. Aucun tracking, aucune pub.",
    de: "Wir verwenden nur essenzielle Cookies für Login und Sprache. Kein Tracking, keine Werbung.",
  };
  const btnAccept = { en: "Accept", it: "Accetta", es: "Aceptar", fr: "Accepter", de: "Akzeptieren" };
  const btnDecline = { en: "Essential only", it: "Solo essenziali", es: "Solo esenciales", fr: "Essentiels uniquement", de: "Nur essenzielle" };
  const learn = { en: "Learn more", it: "Scopri di piu'", es: "Más info", fr: "En savoir plus", de: "Mehr erfahren" };

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 z-[60] rounded-lg border border-white/10 bg-[#121218]/95 backdrop-blur-xl p-4 md:p-5 shadow-[0_20px_60px_rgba(0,0,0,0.6)] flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-6"
      role="dialog"
      aria-live="polite"
    >
      <div className="flex-1 text-sm text-zinc-300 leading-relaxed">
        <span className="text-orange-400 mr-2">🍪</span>
        {text[lang] || text.en}
        {" "}
        <Link to="/cookie" className="text-orange-400 hover:text-orange-300 underline underline-offset-2">
          {learn[lang] || learn.en}
        </Link>
      </div>
      <div className="flex gap-2 flex-shrink-0">
        <Button
          onClick={decline}
          variant="outline"
          className="rounded-full border-white/10 bg-transparent text-white hover:bg-white/5 text-sm"
          data-testid="cookie-decline-btn"
        >
          {btnDecline[lang] || btnDecline.en}
        </Button>
        <Button
          onClick={accept}
          className="rounded-full bg-orange-500 hover:bg-orange-600 text-black font-bold text-sm"
          data-testid="cookie-accept-btn"
        >
          {btnAccept[lang] || btnAccept.en}
        </Button>
      </div>
    </div>
  );
}
